module.exports = __webpack_public_path__ + "img/56201dd.jpg";